import React from 'react';
import {
  Pane, Table, Text,
} from 'evergreen-ui';
import { useGetMessageIncomingByIdQuery } from 'Services/api/messageApi';
import { UTCtoTimeZone } from 'Utils/UTCConverter';
import { useGetChannelsQuery } from 'Services/api/channelMessagesApi';
import SuspenseSpinner from 'Utils/SuspenseSpinner';
import { INCOMING, MessagesTable } from 'Features/Stations/Station/Messages/messageUtils';
import MessagesPanel from 'Features/Stations/Station/Messages/Station.Messages.Panel';
import RepeatMessageProcess from './RepeatMessage';

export function MessagesIncoming({ hasRepeatSend = false, params, useGetStatusQuery, useGetMessagesIncomingQuery }) {
  const { isFetching: isLoadingChannels } = useGetChannelsQuery();

  const headers = React.useMemo(() => {
    const cols = [
      { name: `Дата поступления UTC${params.timeZone}`, cellProps: {} },
      { name: 'Канал сообщения', cellProps: {} },
      { name: 'Статус', cellProps: { } },
    ];
    hasRepeatSend && cols.push({ name: '', cellProps: { flexBasis: 56, flexShrink: 0, flexGrow: 0 } });
    return cols;
  }, [hasRepeatSend, params.timeZone]);

  const RowCells = React.useCallback(({ message }) => {
    const { dateTime, channel, status, id } = message;
    return (
      <>
        <Table.Cell>
          <Text>{dateTime ? UTCtoTimeZone(dateTime, params.timeZone) : 'нет срока'}</Text>
        </Table.Cell>
        <Table.Cell>
          <Text>{channel?.description}</Text>
        </Table.Cell>
        <Table.Cell>
          <Text>{status?.status}</Text>
        </Table.Cell>
        {
          hasRepeatSend
            ? (
              <Table.Cell
                flexBasis={56}
                flexShrink={0}
                flexGrow={0}
                onClick={(e) => e.stopPropagation()}
              >
                <RepeatMessageProcess messageId={id} />
              </Table.Cell>
            )
            : null
        }
      </>
    );
  }, [hasRepeatSend, params.timeZone]);

  if (isLoadingChannels) return <SuspenseSpinner />;

  return (
    <Pane display="grid" gridTemplateRows="max-content 1fr" padding=".5rem" rowGap=".5rem">
      <MessagesPanel params={params} type={INCOMING} useGetStatusQuery={useGetStatusQuery} useGetMessages={useGetMessagesIncomingQuery}/>
      <MessagesTable
        type={INCOMING}
        params={params}
        mode="table"
        headers={headers}
        RowCells={RowCells}
        useGetMessages={useGetMessagesIncomingQuery}
        useGetMessageFileQuery={useGetMessageIncomingByIdQuery}
      />
    </Pane>
  );
}
